/**
 * @generated SignedSource<<bb29aba8865d64c87d88782c5a787c46>>
 * @relayHash 0acc5ecd092c0b13730a68d934bf7c62
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6ca34dc382fbe12f7e08df67b8085ce95cb28bc98ce1beed3f33150fdb96a679

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceUserPermissionsQuery$variables = {
  permissionId: string;
  resourceId: string;
};
export type ConfluenceUserPermissionsQuery$data = {
  readonly permitted: boolean | null;
};
export type ConfluenceUserPermissionsQuery = {
  response: ConfluenceUserPermissionsQuery$data;
  variables: ConfluenceUserPermissionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "permissionId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "resourceId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "permissionId",
        "variableName": "permissionId"
      },
      {
        "kind": "Variable",
        "name": "resourceId",
        "variableName": "resourceId"
      }
    ],
    "kind": "ScalarField",
    "name": "permitted"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ConfluenceUserPermissionsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfluenceUserPermissionsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "6ca34dc382fbe12f7e08df67b8085ce95cb28bc98ce1beed3f33150fdb96a679",
    "metadata": {},
    "name": "ConfluenceUserPermissionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "09d3f73fa0f06eb57117244c67f52367";

export default node;
